export const USERNAME_MATCHER = /^[^ `~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]*$/;

export const getFullName = ({
  firstName,
  lastName,
}: {
  firstName?: string | null;
  lastName?: string | null;
}) => `${firstName ?? ""}${firstName && lastName ? " " : ""}${lastName ?? ""}`;
